import { config } from "@config";

export const REDDIT_SHARE_URL = `${config.externalPaths["reddit"]["url"]}?url={url}&title={text}`;
export const FACEBOOK_SHARE_URL = `${config.externalPaths["facebook"]["url"]}?u={url}`;
export const LINKEDIN_SHARE_URL = `${config.externalPaths["linkedin"]["url"]}?url={url}`;
export const TWITTER_SHARE_URL = `${config.externalPaths["twitter"]["url"]}?url={url}&text={text}`;
export const SOCIAL_TRADING_SHARE_URL = `${config.appUrl}invite/{refId}/trade/buy/{assetId}`;
export const SOCIAL_TRADING_ADP_SHARE_URL = `${config.appUrl}asset/{assetId}`;

export const URL_PLACEHOLDER = "{url}";
export const TEXT_PLACEHOLDER = "{text}";
export const REFERRER_PLACEHOLDER = "{refId}";
export const ASSET_PLACEHOLDER = "{assetId}";

export const TRADE_LOCAKEY = "share_trade_message";
export const ADP_LOCAKEY = "share_adp_message";
